import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './styles/main.css';
import './styles/theme.css';
import { initFacebookPixel } from './utils/fbPixel';

// Initialize Facebook Pixel only once
if (typeof window !== 'undefined' && !window._fbPixelInitialized) {
  console.log('Initializing Facebook Pixel');
  initFacebookPixel();
  window._fbPixelInitialized = true;
}

// Note: The showPixelBlockedGuidance function is called inside initFacebookPixel
// when the pixel is blocked, so we don't need to call it here explicitly.

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
